import { createContext } from 'react';
import { UseBookingStateContextValue } from './UseBookingStateContextValue';

export const BookingStateContext = createContext<UseBookingStateContextValue | null>(null);
